<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
    <meta name="theme-color" content="#17101f" />
    <meta name="description" content="Color Alchemy: simple three-button color mixing." />
    <link rel="icon" type="image/svg+xml" href="/color-alchemy/favicon.svg" />
    <title>Color Alchemy</title>
  </head>
  <body>
    <main id="app"></main>
    <script type="module" src="/src/main.ts"></script>
  </body>
</html>
